import React, { SVGProps } from 'react';

export default function SvgOpeningHours(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9 2.29991C4.80721 2.29991 2.3 4.80711 2.3 7.89991C2.3 10.9927 4.80721 13.4999 7.9 13.4999C10.9928 13.4999 13.5 10.9927 13.5 7.89991C13.5 4.80711 10.9928 2.29991 7.9 2.29991ZM1.5 7.89991C1.5 4.36529 4.36538 1.49991 7.9 1.49991C11.4346 1.49991 14.3 4.36529 14.3 7.89991C14.3 11.4345 11.4346 14.2999 7.9 14.2999C4.36538 14.2999 1.5 11.4345 1.5 7.89991Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.47141 4.92847C7.69233 4.92847 7.87141 5.10755 7.87141 5.32847L7.87141 7.32323L9.95211 9.74798C10.096 9.91563 10.0767 10.1682 9.90904 10.312C9.74139 10.4559 9.48886 10.4366 9.345 10.269L7.16785 7.73181C7.10562 7.65929 7.07141 7.56689 7.07141 7.47132L7.07141 5.32847C7.07141 5.10755 7.2505 4.92847 7.47141 4.92847Z"
        fill="currentColor"
      />
    </svg>
  );
}
